<template>
  <div id="app">
    <loading></loading>
    <router-view/>
  </div>
</template>

<script>
import loading from '@/components/loading.vue'
export default {
  name: 'App',
  components: {
    loading
  }
}
</script>

<style>
.immersive-top {
  /* padding-top: 35px; */
}
</style>


// WEBPACK FOOTER //
// src/App.vue